import { registerTab } from "lib/@components/tabs"
import { isEnabled } from "lib/@components/feature"
import { Lazy } from "lib/make-lazy"
import { FEATURE_FLAG_LEGISLATION_RESOLUTIONS } from "routes/schedule/plugins/legislation-resolutions/feature-flag-legislation-resolutions"

registerTab({
    tab: "sfg20AdminTabs",
    id: "legislationCompliance",
    title: "Legislation Compliance",
    demands: "admin",
    predicate: () => isEnabled(FEATURE_FLAG_LEGISLATION_RESOLUTIONS),
    content: (
        <Lazy
            importer={() => import("routes/sfg20-admin/plugins/legislation-compliance-tab/legislation-compliance-tab")}
            extract="LegislationComplianceTab"
            priority={20}
        />
    ),
})
